import { FormikProps } from "formik";
import Flex from "../../../../../../../../../../components/Flex";
import useDisclosure from "../../../../../../../../../../hooks/use-disclosure";
import { StyleAddButton } from "../../../../../../../scheduling/appointment/encounter/default-forms/form-1/StyledAddButton";
import { AddCptCodes, renderSelectedCptCodes } from "./Add-CPT-Codes";

interface CptCodesFieldProps {
  formik: FormikProps<any>;
  label?: string;
  height?: string;
}

/**
 * Renders the "Add CPT Codes" button, the picker drawer, and the selected
 * codes list. Designed to sit side-by-side with `IcdCodesField` inside a
 * row-direction flex container.
 *
 * Values live on `formik.values.procedureCodes`.
 */
const CptCodesField = ({
  formik,
  label = "Add CPT Codes",
  height = "20vh",
}: CptCodesFieldProps) => {
  const cptDisclosure = useDisclosure();

  return (
    <Flex flexDirection="column" gap={1} flex={1} minWidth={0}>
      <StyleAddButton
        w="120px"
        onClick={() => cptDisclosure.open()}
        label={label}
      />
      <AddCptCodes formik={formik} disclosureHost={cptDisclosure} />
      {!!formik.values?.procedureCodes?.length && (
        <Flex flexDirection={"column"} width={"100%"} gap={1}>
          {renderSelectedCptCodes(
            formik.values?.procedureCodes ?? [],
            (code: any) => {
              formik.setFieldValue("procedureCodes", [
                ...(formik.values?.procedureCodes ?? []).filter(
                  (it: any) => it.value !== code.value
                ),
              ]);
            },
            height
          )}
        </Flex>
      )}
    </Flex>
  );
};

export default CptCodesField;
